module.exports = __webpack_public_path__ + "static/media/Picker_specifiques_elN310_1915790896.4b6ccab4.png";